import { createContext, useContext } from 'react';
import FilterStore from '../FilterTemplate/Store';
import SortStore from '../SortTemplate/Store';
import { Maybe, nothing } from 'maybeasy';

interface FilterStoresProps {
  productTypeFilterStore: FilterStore;
  durationFilterStore: FilterStore;
  competencyFilterStore: FilterStore;
  schoolPartnerFilterStore: FilterStore;
  languageFilterStore: FilterStore;
  sortStore: SortStore;
}

export const FilterStores = createContext<Maybe<FilterStoresProps>>(nothing());

export const useFilterStoreContext = () => useContext(FilterStores);
